import { useRef } from 'react';
import { KEYS, LOCALE_LABELS } from '../../../../l18n/constants';
import handleClick from '../../../../utils/handleClick';
import computeClassName from '../../../../utils/computeClassName';
import { useL18nContext } from '../../ContextProvider/L18n';
import useClickOutside from '../../../../hooks/ui/useClickOutside';
import CCIconClose20x20 from '../../../libs/CiscoCore/Icon/Close/20x20';
import CCIconCheck16x16 from "../../../libs/CiscoCore/Icon/Check/16x16";

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-primary shadow-cc-menu px-6 flex items-center justify-center w-full h-screen sm:w-72 sm:h-40 sm:mr-20'
});

const propsDefaults = Object.freeze({
  toggleOffLanguageMenuFn: null,
});

export default function LanguageMenu(
  {
    toggleOffLanguageMenuFn = propsDefaults.toggleLanguageMenuFn,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor, currentLocale, updateCurrentLocale } = useL18nContext();
  const translatedLabelTitleButtonClose = getTranslationFor(KEYS.L18N_KEY_LABEL_CLOSE);
  const translatedLabelChooseLanguageSelection = getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION);
  const closeButtonClickFn = handleClick(toggleOffLanguageMenuFn);
  const menuRef = useRef();

  function selectLanguageAndClose(selectedLanguageLocale) {
    updateCurrentLocale(selectedLanguageLocale);
    toggleOffLanguageMenuFn();
  }

  useClickOutside(menuRef, toggleOffLanguageMenuFn);

  return (
    <div className={computedClassName} ref={menuRef}>
      <button className="appearance-none absolute top-cc-3.75 right-cc-3.75 z-10"
              title={translatedLabelTitleButtonClose}
              onClick={closeButtonClickFn}>
        <CCIconClose20x20 aria-hidden="true" className="w-5 h-5"/>
      </button>
      <div className="absolute top-0 left-0 h-full w-full overflow-y-auto px-6">
        <p className="bg-cc-primary sticky top-0 w-full text-cc-secondary-contrast text-left pt-5 pb-4">{translatedLabelChooseLanguageSelection}</p>
        <ul className="list-none mb-4">
          {
            Object.keys(LOCALE_LABELS).map(
              ( languageLabelKey, index) => {
                return (
                  <li key={index}>
                    {
                      languageLabelKey === currentLocale ?
                        <button className="appearance-none text-cc-primary-contrast py-1.5 inline-flex items-center"><span className="text-cc-accent"><CCIconCheck16x16 className="w-4 h-4"/></span><span className="ml-1">{LOCALE_LABELS[languageLabelKey]}</span></button> :
                        <button className="appearance-none text-cc-accent py-1.5 font-semibold" onClick={handleClick(selectLanguageAndClose,languageLabelKey)}>{LOCALE_LABELS[languageLabelKey]}</button>
                    }
                  </li>
                );
              }
            )
          }
        </ul>
      </div>
    </div>
  );
}
